import { zodResolver } from "@hookform/resolvers/zod";
import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import {
  modalHeightVariants,
  modalVariants,
} from "../../animation/RoutesAnimations";
import { mobileNumberSchema } from "../../utils/customSchemas";
import customZ from "../../utils/setZodCustomMessages";
import EnterPhoneNumber from "../login/EnterPhoneNumber";
import EnterOtp from "../login/EnterOtp";
import LogedInBefor from "../login/LogedInBefor";
import AcceptRules from "../login/AcceptRules";
import NewPasswordSetter from "../login/NewPasswordSetter";
import ForgetPasswordStepsModal from "./ForgetPasswordStepsModal";

interface ModalProps {
  onClose: () => void;
  navigateHere?: string;
  open_PhoneNumber?: boolean;
  open_OtpCode?: boolean;
  open_Rule?: boolean;
  open_NewPassword?: boolean;
  loged_InBefor?: boolean;
  phoneNumber?: string;
  setEnteredUser?: any;
}

export interface IStep2Schemas {
  phone_number: string;
  otpCodeNumber: string;
  password: string;
  confirmPassword: string;
}

const ModalComponents: React.FC<ModalProps> = ({
  onClose,
  navigateHere,
  open_PhoneNumber,
  open_OtpCode,
  open_Rule,
  open_NewPassword,
  loged_InBefor,
  setEnteredUser,
}) => {
  const modalContentRef = useRef<HTMLDivElement>(null);
  const [otp_ticket, setOtp_ticket] = useState<string | null>(null);

  const [openPhoneNumber, setOpenPhoneNumber] = useState<boolean>(false);
  const [openOtpCode, setOpenOtpCode] = useState<boolean>(
    open_OtpCode ?? false
  );
  const [openRule, setOpenRule] = useState<boolean>(open_Rule ?? false);
  const [openNewPassword, setOpenNewPassword] = useState<boolean>(
    open_NewPassword ?? false
  );
  const [logedInBefor, setLogedInBefor] = useState<boolean>(true);
  const [forgetPassword, setForgetPassword] = useState<boolean>(false);

  const closeModal = () => {
    onClose();
    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("overflow-hidden");
    }
  };

  const closeModalNotSetPassword = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    onClose();
    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("overflow-hidden");
    }
  };

  const phoneSchema = customZ.object({
    phone_number: mobileNumberSchema,
  });

  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm<IStep2Schemas>({
    resolver: (data, context, options) => {
      return zodResolver(phoneSchema)(data, context, options);
    },
  });

  const handleEnterPhone = () => {
    setOpenPhoneNumber(false);
    setOpenOtpCode(true);
  };

  const handleRulesAccepted = () => {
    setOpenRule(false);
    setOpenNewPassword(true);
  };

  const handleOtpRequest = () => {
    setOpenPhoneNumber(false);
    setOpenOtpCode(false);
    setOpenRule(true);
  };

  const handleOtpClose = () => {
    setOpenPhoneNumber(true);
    setOpenOtpCode(false);
  };

  const handleSetOpenRule = () => {
    setOpenPhoneNumber(false);
    setOpenOtpCode(false);
    setOpenRule(true);
  };

  const goToLogin = () => {
    setLogedInBefor(true);
    setOpenPhoneNumber(false);
  };

  const forgetPasswordModal = () => {
    setLogedInBefor(false);
    setForgetPassword(true);
    setOpenPhoneNumber(false);
  };

  const goToOTP = () => {
    setLogedInBefor(false);
    setForgetPassword(false);
    setOpenPhoneNumber(true);
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };

  const goToMainLoginModal = () => {
    setLogedInBefor(true);
    setForgetPassword(false);
    setOpenPhoneNumber(false);
  };

  return ReactDOM.createPortal(
    <motion.div
      variants={modalVariants}
      initial="initial"
      animate="final"
      id="static-modal"
      data-modal-backdrop="static"
      tabIndex={-1}
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-screen bg-gray-500 bg-opacity-50"
    >
      <motion.div
        layout
        variants={modalHeightVariants}
        initial="initial"
        animate="final"
        className="relative w-[316px] md:w-[416px] max-w-[416px] overflow-hidden bg-white rounded-lg shadow "
      >
        <motion.div
          layout={"position"}
          initial="initial"
          animate="final"
          className="relative "
          onClick={stopPropagation}
        >
          {openPhoneNumber ? (
            <EnterPhoneNumber
              handleSubmit={handleSubmit}
              control={control}
              errors={errors}
              onEnterPhone={handleEnterPhone}
              goToLogin={goToLogin}
              closeModal={closeModal}
              otp_ticket={otp_ticket}
              setOtp_ticket={setOtp_ticket}
            />
          ) : logedInBefor ? (
            <LogedInBefor
              errors={errors}
              modalContentRef={modalContentRef}
              goToOTP={goToOTP}
              forgetPasswordModal={forgetPasswordModal}
              closeModal={closeModal}
              navigateHere={navigateHere}
            />
          ) : forgetPassword ? (
            <ForgetPasswordStepsModal
              goToMainLoginModal={goToMainLoginModal}
              onClose={onClose}
              setOpenPhoneNumber={setOpenPhoneNumber}
              modalContentRef={modalContentRef}
              forgetPassword={forgetPasswordModal}
              closeModal={closeModal}
              navigateHere={navigateHere}
            />
          ) : openOtpCode ? (
            <EnterOtp
              setEnteredUser={setEnteredUser}
              handleSubmit={handleSubmit}
              watch={watch}
              control={control}
              errors={errors}
              getValues={getValues}
              goToLogin={goToLogin}
              onOtpHandled={handleOtpRequest}
              otpClose={handleOtpClose}
              otp_ticket={otp_ticket}
              navigateHere={navigateHere}
              closeModal={closeModal}
              onOpemRules={handleSetOpenRule}
              setOtp_ticket={setOtp_ticket}
              setValue={setValue}
            />
          ) : openRule ? (
            <AcceptRules
              modalContentRef={modalContentRef}
              onRulesAccepted={handleRulesAccepted}
              onOpemRules={handleSetOpenRule}
              closeModalNotSetPassword={closeModalNotSetPassword}
            />
          ) : (
            openNewPassword && (
              <NewPasswordSetter
                setEnteredUser={setEnteredUser}
                closeModalNotSetPassword={closeModalNotSetPassword}
                closeModal={closeModal}
                getValues={getValues}
                goToLogin={goToLogin}
                onOtpHandled={handleOtpRequest}
                otpClose={handleOtpClose}
                otp_ticket={otp_ticket}
                navigateHere={navigateHere}
              />
            )
          )}
        </motion.div>
      </motion.div>
    </motion.div>,

    document.getElementById("modal-root")!
  );
};

export default ModalComponents;
